import { t } from '@transifex/native'
import M365Copilot from '../images/M365Copilot.png'

const Microsoft365Icon: React.FC = () => {
  return (
    <img
      src={M365Copilot}
      alt={t('Microsoft 365')}
      style={{ width: 28, height: 28, objectFit: 'contain' }}
    />
  )
}

export default Microsoft365Icon
